// import { basicSetup, EditorView } from 'codemirror';
// import { EditorState } from '@codemirror/state';
// import { sql } from '@codemirror/lang-sql';

import Drawer from '@/components/Dashboard/common/Drawer';
import {
    DefaultDropdownBox,
    SelectedBox,
} from '@/components/Common/DropdownBox';
import { generateId, isValueExist } from '@/utils/utils';

import * as S from './style';
import { VERTICAL_SPACER } from '@/styles/common.styled.component';
import StatusInput from '@/components/Common/StatusInput';
import { ExportDataService } from '@/services';
import { mapMutations } from 'vuex';

// import { linter } from '@codemirror/lint';

import InfoIcon from '@svgIcons/info_line.svg';
import TrashIcon from '@svgIcons/trashcan.svg';
import CheckCircleIcon from '@svgIcons/check_circle.svg';
import DropdownButton from '@/components/Common/DropdownButton';
// import Dropdown from '@/components/Common/Dropdown';
import Dialog from '@/components/Common/Dialog';
import { filter } from 'rxjs/operators';
import MetricTypeEditor from './MetricEditor';
import TranslatorMixin from './MetricEditor/translator.mixin';
import DimensionTypeEditor from './DimensionEditor';
import SQLEditor from './SQLEditor';
import CustomTableIcon from '@svgIcons/datastream/custom-table.svg';
import FullArchitectureIcon from '@svgIcons/datastream/full-architecture.svg';
import {
    countFilters,
    countFullFilters,
    getOuterConditions,
} from './DimensionEditor/utils';
import { FULL_ARCHITECTURE } from './SelectStream';

const DATASTREAM = 'datastream';
const CONNECTION = 'connection';

export const FIELD_PANEL_ORIGIN = {
    [DATASTREAM]: DATASTREAM,
    [CONNECTION]: CONNECTION,
};

const START_FROM_SCRATCH = 'startFromScratch';
const CHOOSE_FROM_TEMPLATES = 'chooseFromTemplates';

const OPTIONS = {
    [START_FROM_SCRATCH]: {
        title: 'EXPORT_DATA.field_option_start_from_scratch',
        description: 'EXPORT_DATA.field_option_start_from_scratch_description',
        icon: CustomTableIcon,
    },
    [CHOOSE_FROM_TEMPLATES]: {
        title: 'EXPORT_DATA.field_option_choose_from_templates',
        description:
            'EXPORT_DATA.field_option_choose_from_templates_description',
        icon: FullArchitectureIcon,
    },
};

const CUSTOM_FIELD_CREATION_OPTION_PAGE = 'customFieldCreationOption';
const EDITOR_PANEL_PAGE = 'editorPanel';

const EDITOR_MODE = {
    dimension: 'dimension',
    metric: 'metric',
    sql: 'sql',
};

export default {
    name: 'CustomFieldPanel',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        selectedField: {
            type: Object,
            default() {
                return {};
            },
        },
        customFields: {
            type: Array,
            default() {
                return [];
            },
        },
        origin: {
            type: String,
            default: DATASTREAM, // 'connection'
        },
        categoryLocaleMap: {
            type: Object,
            default() {
                return {};
            },
        },
        availableMetricList: {
            type: Array,
            default() {
                return [];
            },
        },
        availableBreakdownList: {
            type: Array,
            default() {
                return [];
            },
        },
        translator: {
            type: Function,
        },
        isMarketing: {
            type: Boolean,
        },
        streamType: {
            type: String,
        },
    },
    data() {
        return {
            // editor: null,
            code: '',
            mode: {},
            name: '',
            templates: [],
            selectedTemplate: {},
            dropdownVisible: false,
            newTemplateName: '',
            newTemplateNameDuplicated: false,
            newTemplateModalOpen: false,
            page: this.selectedField
                ? EDITOR_PANEL_PAGE
                : CUSTOM_FIELD_CREATION_OPTION_PAGE,
            fieldCreationOption: START_FROM_SCRATCH,
            initialized: false,
            shouldUpdateEditor: false,
        };
    },
    mixins: [TranslatorMixin],
    watch: {
        code(newCode) {
            if (this.initialized) {
                this.$emit('setHasCustomFieldChanged', true);
            }
        },
        selectedField(newField) {
            if (this.active) {
                this.shouldUpdateEditor = true;
            }
        },
    },
    computed: {
        isEditing: R.propSatisfies(isValueExist, 'selectedField'),
        elseCaseExists() {
            const lastCond = this.code && this.code[0]?.conditions;
            const lastItem = lastCond && lastCond[lastCond.length - 1];
            const elseCaseExists = lastItem?.isElse ?? false;

            return elseCaseExists;
        },
        isCustomFieldUserWithFullArch() {
            return this.streamType === FULL_ARCHITECTURE;
        },
    },
    methods: {
        ...mapMutations('view', ['setNotiMsgs']),
        resetStates() {
            // this.editor = null;
            this.code = '';
            this.name = '';
            this.mode = {};
            this.$emit('setSelectedField', null);
        },
        renderCodeEditor() {
            switch (this.mode.id) {
                case EDITOR_MODE.dimension: {
                    const props = {
                        attrs: {
                            customFilterList: this.code,
                            isMarketing: this.isMarketing,
                            categoryLocaleMap: this.categoryLocaleMap,
                            availableBreakdownList: this.availableBreakdownList,
                            elseCaseExists: this.elseCaseExists,
                        },
                        on: {
                            setCode: (v) => (this.code = v),
                        },
                    };

                    return <DimensionTypeEditor {...props} />;
                }
                case EDITOR_MODE.metric: {
                    const props = {
                        attrs: {
                            formula: this.code,
                            fields: this.availableMetricList,
                            shouldUpdateEditor: this.shouldUpdateEditor,
                        },
                        on: {
                            setCode: (v) => (this.code = v),
                            setShouldUpdateEditor: (v) =>
                                (this.shouldUpdateEditor = v),
                        },
                    };

                    return <MetricTypeEditor {...props} />;
                }
                case EDITOR_MODE.sql: {
                    // console.log('>>> sql this code', this.code);
                    const props = {
                        attrs: {
                            queryString: this.code,
                        },
                        on: {
                            setCode: (v) => (this.code = v),
                        },
                    };

                    return <SQLEditor {...props} />;
                }
                default: {
                    return;
                }
            }
        },
        renderName() {
            return (
                <S.CustomFieldNameWrapper>
                    <div class="name-title">
                        {this.$t('EXPORT_DATA.custom_field_name_title')}
                    </div>
                    <S.InputWrapper>
                        <StatusInput
                            value={this.name}
                            onInput={(v) => (this.name = v)}
                            counterVisible={false}
                            placeholder={this.$t(
                                'EXPORT_DATA.custom_Field_name_placeholder'
                            )}
                            cleaner={R.replace(
                                /[\s&/#,+()$~%.'":*?<>{}-]/gi,
                                ''
                            )}
                            maxLength={64}
                        />
                    </S.InputWrapper>
                    <S.CustomFieldNameDesc>
                        <span>
                            {`- ${this.$t(
                                'EXPORT_DATA.custom_field_name_instruction_1'
                            )}`}
                        </span>
                        {`- ${this.$t(
                            'EXPORT_DATA.custom_field_name_instruction_2'
                        )}`}
                    </S.CustomFieldNameDesc>
                </S.CustomFieldNameWrapper>
            );
        },
        resetEditor() {
            this.code = '';
            this.mode = {};
        },
        onClickTemplateDropdownOption(v) {
            this.resetEditor();
            this.selectedTemplate = v;
            this.updateEditor(v);

            this.dropdownVisible = false;
        },
        onClickModeDropdownOption(v) {
            this.resetEditor();
            this.mode = v;

            this.dropdownVisible = false;
        },
        async onClickDeleteTemplate(option) {
            try {
                await ExportDataService.deleteCustomField([option.id]);

                if (option.id === this.selectedTemplate.id) {
                    this.selectedTemplate = {};
                    this.resetEditor();
                }

                this.getTemplates();
            } catch (error) {
                console.error(error);
            }
        },
        renderTemplateDropdown() {
            const { selectedTemplate, templates, dropdownVisible } = this;
            const boxProps = {
                attrs: {
                    selectedOption: selectedTemplate,
                    translator: (item) => {
                        const name = item?.name ?? '';
                        return (
                            <S.TemplateDropdownBoxWrapper>
                                <CheckCircleIcon
                                    v-view-box
                                    class="circle-icon"
                                />
                                <span>
                                    {name ||
                                        this.$t(
                                            'EXPORT_DATA.choose_from_templates'
                                        )}
                                </span>
                            </S.TemplateDropdownBoxWrapper>
                        );
                    },
                    className: 'template-box-wrapper',
                },
                on: {
                    click: () => (this.dropdownVisible = !this.dropdownVisible),
                },
            };

            const _templates = this.isCustomFieldUserWithFullArch
                ? templates.filter(
                      (t) =>
                          t.customMode === EDITOR_MODE.metric ||
                          t.customMode === EDITOR_MODE.sql
                  )
                : templates;

            const dropdownProps = {
                attrs: {
                    isVisible: dropdownVisible,
                    optionList: _templates,
                    translator: R.propOr('', 'name'),
                    selectedOption: selectedTemplate,
                    width: 200,
                    additionalIconRenderer: (option) => {
                        // if (option.id === 'newQuery') return '';
                        return (
                            <S.TeamplateDropdownItemWrapper>
                                <TrashIcon
                                    v-view-box
                                    class="trash-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        return this.dialog({
                                            confirmText:
                                                this.$t('COMMON.delete'),
                                            confirmCb: () => {
                                                this.onClickDeleteTemplate(
                                                    option
                                                );
                                            },
                                            confirmType: 'danger',
                                            text: this.$t(
                                                'EXPORT_DATA.custom_field_template_delete_asking'
                                            ),
                                        });
                                    }}
                                />
                            </S.TeamplateDropdownItemWrapper>
                        );
                    },
                },
                on: {
                    confirm: (v) => {
                        if (
                            this.selectedTemplate.id &&
                            v.id !== this.selectedTemplate.id
                        ) {
                            return this.dialog({
                                confirmText: this.$t('COMMON.apply'),
                                text: this.$t(
                                    'EXPORT_DATA.custom_field_template_ovewrite_asking'
                                ),
                                confirmCb: () =>
                                    this.onClickTemplateDropdownOption(v),
                            });
                        } else {
                            this.onClickTemplateDropdownOption(v);
                        }
                    },
                    clickOutside: () => (this.dropdownVisible = false),
                },
            };
            return (
                <S.TemplateBoxWrapper>
                    <SelectedBox {...boxProps} />
                    <DefaultDropdownBox {...dropdownProps} />
                </S.TemplateBoxWrapper>
            );
        },
        renderModeOptionDropdown() {
            const { mode, dropdownVisible } = this;
            const boxProps = {
                attrs: {
                    selectedOption: mode,
                    translator: (item) => {
                        const name = item?.name ?? '';
                        return (
                            <S.TemplateDropdownBoxWrapper>
                                <CheckCircleIcon
                                    v-view-box
                                    class="circle-icon"
                                />
                                <span>
                                    {name ||
                                        this.$t(
                                            'EXPORT_DATA.choose_editor_mode'
                                        )}
                                </span>
                            </S.TemplateDropdownBoxWrapper>
                        );
                    },
                    className: 'template-box-wrapper',
                },
                on: {
                    click: () => (this.dropdownVisible = !this.dropdownVisible),
                },
            };

            const _optionList = this.isCustomFieldUserWithFullArch
                ? [
                      {
                          id: EDITOR_MODE.metric,
                          name: this.$t('EXPORT_DATA.editor_mode_metric'),
                      },
                      {
                          id: EDITOR_MODE.sql,
                          name: this.$t('EXPORT_DATA.editor_mode_sql'),
                      },
                  ]
                : [
                      {
                          id: EDITOR_MODE.dimension,
                          name: this.$t('EXPORT_DATA.editor_mode_dimension'),
                      },
                      {
                          id: EDITOR_MODE.metric,
                          name: this.$t('EXPORT_DATA.editor_mode_metric'),
                      },
                      {
                          id: EDITOR_MODE.sql,
                          name: this.$t('EXPORT_DATA.editor_mode_sql'),
                      },
                  ];

            const dropdownProps = {
                attrs: {
                    isVisible: dropdownVisible,
                    optionList: _optionList,
                    translator: R.propOr('', 'name'),
                    selectedOption: mode,
                    width: 200,
                },
                on: {
                    confirm: (v) => {
                        if (v.id === mode.id) return;
                        this.onClickModeDropdownOption(v);
                    },
                    clickOutside: () => (this.dropdownVisible = false),
                },
            };
            return (
                <S.TemplateBoxWrapper>
                    <SelectedBox {...boxProps} />
                    <DefaultDropdownBox {...dropdownProps} />
                </S.TemplateBoxWrapper>
            );
        },
        updateEditor(v) {
            const { query, name, customMode, status } = v;

            this.name = name;
            this.mode = {
                id: customMode,
                name: this.$t(`EXPORT_DATA.editor_mode_${customMode}`),
            };
            this.code =
                customMode === EDITOR_MODE.metric ? query.toString() : query;
            this.initialized = true;
            this.fieldCreationOption =
                status === 'template'
                    ? CHOOSE_FROM_TEMPLATES
                    : START_FROM_SCRATCH;
        },
        observeSelectedField$() {
            const { generateWatchNew$: gen$ } = this;

            const selectedItem$ = gen$('selectedField').pipe(
                filter(isValueExist)
            );

            this.$subscribeTo(selectedItem$, (v) => {
                this.updateEditor(v);
            });
        },
        numberOfFilters() {
            const { code, elseCaseExists } = this;
            const count = countFilters(code);

            return elseCaseExists ? count - 1 : count;
        },
        numberOfFullFilters() {
            const { code, elseCaseExists } = this;
            const count = countFullFilters(code, elseCaseExists);

            return count;
        },
        hasCustomFieldValueFilled() {
            const { code } = this;
            const outerConditions = getOuterConditions(code);
            const filtersWithNoValue = outerConditions.filter(
                (cond) => !cond.customFieldValue
            );

            return filtersWithNoValue.length === 0;
        },
        confirmDimensionFiltersDisabled() {
            const {
                name = '',
                numberOfFullFilters,
                numberOfFilters,
                hasCustomFieldValueFilled,
            } = this;

            return (
                !name.trim() ||
                numberOfFullFilters() === 0 ||
                numberOfFullFilters() !== numberOfFilters() ||
                !hasCustomFieldValueFilled()
            );
        },
        refineCode(customMode) {
            if (customMode === EDITOR_MODE.metric) {
                return this.reverseFormulaTranslator(this.code);
            }

            if (customMode === EDITOR_MODE.sql) {
                return this.code?.replace(/\n+$/, '') ?? '';
            }

            return this.code;
        },
        async createCustomField() {
            if (!this.checkIsValid()) return;

            const trimmed = R.trim(this.name);

            try {
                const refinedQuery = this.refineCode(this.mode.id);

                if (this.mode.id === EDITOR_MODE.sql) {
                    await ExportDataService.checkQueryValidation({
                        queryLanguage: 'postgresql',
                        query: refinedQuery,
                    });
                }

                const params = {
                    query: refinedQuery,
                    queryLanguage: 'postgresql',
                    customMode: this.mode.id,
                };

                // await ExportDataService.checkQueryValidation(validationParam);
                const field = {
                    ...params,
                    name: trimmed,
                    status: 'draft',
                    id: 'temporary' + '|' + generateId(),
                };

                this.$emit('setCustomFields', [...this.customFields, field]);
                this.$emit('setHasCustomFieldChanged', true);

                this.setNotiMsgs([
                    {
                        type: 'SUCCESS',
                        title: this.$t(
                            'EXPORT_DATA.custom_field_create_new_message'
                        ),
                    },
                ]);
                this.onCancel();
            } catch (error) {
                this.handleError(error);
            }
        },
        async editCustomField() {
            if (!this.checkIsValid()) return;

            const trimmed = R.trim(this.name);

            try {
                const { queryLanguage } = this.selectedField;
                const refinedQuery = this.refineCode(this.mode.id);

                if (this.mode.id === EDITOR_MODE.sql) {
                    await ExportDataService.checkQueryValidation({
                        queryLanguage,
                        query: refinedQuery,
                    });
                }

                const field = {
                    ...this.selectedField,
                    query: refinedQuery,
                    name: trimmed,
                    customMode: this.mode.id,
                };

                const index = R.findIndex(
                    R.propEq('id', field.id),
                    this.customFields
                );

                this.$emit(
                    'setCustomFields',
                    R.set(R.lensIndex(index), field, this.customFields)
                );

                this.$emit('setHasCustomFieldChanged', true);

                this.setNotiMsgs([
                    {
                        type: 'SUCCESS',
                        title: this.$t('EXPORT_DATA.custom_field_edit_message'),
                    },
                ]);
                this.onCancel();
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error = {}) {
            console.error(error);
            const {
                code,
                message,
                properties: { position } = {},
            } = error.response?.data || {};

            const refinedMessage = this.$te(`EXPORT_DATA.error_${code}`)
                ? this.$t(`EXPORT_DATA.error_${code}`, {
                      position,
                  })
                : message;

            this.setNotiMsgs([
                {
                    type: 'FAIL',
                    title: refinedMessage,
                },
            ]);
        },
        async onConfirm() {
            if (this.page === CUSTOM_FIELD_CREATION_OPTION_PAGE) {
                this.page = EDITOR_PANEL_PAGE;
                return;
            }

            if (this.origin === CONNECTION) {
                this.$emit('onInputCustomCode', this.code);
                this.onCancel();
                return;
            }

            if (this.isEditing) {
                return this.dialog({
                    text: this.$t(
                        'EXPORT_DATA.custom_field_edit_confirm_message'
                    ),
                    confirmText: this.$t('COMMON.apply'),
                    confirmCb: this.editCustomField,
                });
            } else {
                this.createCustomField();
            }
        },
        onCancel() {
            this.resetStates();
            this.$emit('activeChange', false);
        },
        checkIsValid() {
            let isValid = false;

            if (
                typeof this.code === 'object' &&
                this.mode.id === EDITOR_MODE.dimension
            ) {
                isValid = !this.confirmDimensionFiltersDisabled();
            } else {
                isValid = this.code?.replace(/\n/g, '').trim() !== '';
            }

            if (this.origin === DATASTREAM) {
                isValid = isValid && Boolean(R.trim(this.name));
            }

            return isValid;
        },
        makeHeaderText() {
            switch (this.origin) {
                case DATASTREAM: {
                    return this.isEditing
                        ? this.$t('EXPORT_DATA.custom_field_edit')
                        : this.$t('EXPORT_DATA.custom_field_create_new');
                }
                case CONNECTION:
                    return this.$t('EXPORT_DATA.code_editor_header');
            }
        },
        makeDesc() {
            switch (this.origin) {
                case DATASTREAM: {
                    return this.$t('EXPORT_DATA.custom_field_desc');
                }
                case CONNECTION:
                    return this.$t('EXPORT_DATA.code_editor_desc');
            }
        },
        async getTemplates() {
            try {
                const templates =
                    await ExportDataService.getCustomFieldTemplates();

                this.templates = templates || [];
            } catch (error) {
                console.error(error);
            }
        },
        renderNewTemplateDialog() {
            if (!this.newTemplateModalOpen) return;

            return (
                <Dialog
                    backdrop={true}
                    active={true}
                    cancelCb={() => {
                        this.newTemplateNameDuplicated = false;
                        this.newTemplateName = '';
                        this.newTemplateModalOpen = false;
                    }}
                    confirmCb={async () => {
                        this.newTemplateNameDuplicated = false;

                        const trimmed = R.trim(this.newTemplateName);
                        if (
                            this.templates.some(
                                (template) => template.name === trimmed
                            )
                        ) {
                            this.newTemplateNameDuplicated = true;
                            return;
                        }

                        const refinedQuery = this.refineCode(this.mode.id);
                        const params = {
                            query: refinedQuery,
                            queryLanguage: 'postgresql',
                            customMode: this.mode.id,
                        };

                        try {
                            await ExportDataService.createCustomField([
                                {
                                    ...params,
                                    name: trimmed,
                                    status: 'template',
                                },
                            ]);

                            await this.getTemplates();

                            this.setNotiMsgs([
                                {
                                    type: 'SUCCESS',
                                    title: this.$t(
                                        'EXPORT_DATA.custom_field_template_success'
                                    ),
                                },
                            ]);
                            this.newTemplateName = '';
                            this.newTemplateModalOpen = false;
                            this.newTemplateNameDuplicated = false;
                        } catch (error) {
                            this.handleError(error);
                        }
                    }}
                    confirmText={this.$t('COMMON.apply')}
                    buttonDisabled={R.trim(this.newTemplateName) === ''}
                >
                    <div>
                        <S.NewTemplateModalTitle>
                            {this.$t(
                                'EXPORT_DATA.custom_field_template_modal_title'
                            )}
                        </S.NewTemplateModalTitle>
                        <StatusInput
                            value={this.newTemplateName}
                            onInput={(v) => (this.newTemplateName = v)}
                            errorText={
                                this.newTemplateNameDuplicated
                                    ? this.$t(
                                          'EXPORT_DATA.custom_field_template_name_already_exist'
                                      )
                                    : ''
                            }
                            counterVisible={false}
                            // cleaner={R.replace(
                            //     /[ \&/#,+()$~%.'":*?<>{}-]/gi,
                            //     ''
                            // )}
                            // maxLength={24}
                        />
                    </div>
                </Dialog>
            );
        },
        renderOptions() {
            const options = Object.entries(OPTIONS);

            return options.map(([key, value]) => {
                const { title, description, icon } = value;
                return (
                    <S.FieldOptionItemWrapper
                        onClick={() => (this.fieldCreationOption = key)}
                        selected={this.fieldCreationOption === key}
                    >
                        <icon />
                        <S.FieldOptionTitle>
                            {this.$t(title)}
                        </S.FieldOptionTitle>
                        <S.FieldOptionItemDescription>
                            {this.$t(description)}
                        </S.FieldOptionItemDescription>
                    </S.FieldOptionItemWrapper>
                );
            });
        },
        tooltipMessage() {
            return this.$t(
                `EXPORT_DATA.custom_field_instruction_tooltip_${this.mode.id}`
            );
        },
    },
    mounted() {
        setTimeout(() => {
            this.observeSelectedField$();
            this.getTemplates();
        }, 0);
    },
    render() {
        const {
            active,
            onCancel,
            origin,
            makeHeaderText,
            makeDesc,
            isEditing,
            onConfirm,
            tooltipMessage,
        } = this;
        const props = {
            attrs: {
                active,
                wrapStyle: { right: '545px' },
                onCancel,
                headerText: makeHeaderText(),
                hasButtons: true,
                onConfirm: onConfirm,
                confirmText:
                    this.page === CUSTOM_FIELD_CREATION_OPTION_PAGE
                        ? this.$t('COMMON.next')
                        : isEditing
                        ? this.$t('COMMON.apply')
                        : this.$t('COMMON.create'),
                confirmDisabled:
                    this.page !== CUSTOM_FIELD_CREATION_OPTION_PAGE &&
                    !this.checkIsValid(),
                wrapClassName: 'codemirror-metric-editor',
            },
        };

        return this.page === CUSTOM_FIELD_CREATION_OPTION_PAGE ? (
            <Drawer {...props}>
                <div>
                    <S.FieldOptionsDescription>
                        {this.$t('EXPORT_DATA.custom_field_creation_option')}
                    </S.FieldOptionsDescription>
                    <S.FieldOptionsWrapper>
                        {this.renderOptions()}
                    </S.FieldOptionsWrapper>
                </div>
                <VERTICAL_SPACER amount={24} style={{ 'flex-shrink': 0 }} />
            </Drawer>
        ) : (
            <Drawer {...props}>
                <portal to="panel_modal">
                    {this.renderNewTemplateDialog()}
                </portal>

                <S.CustomFIeldPanelDesc>{makeDesc()}</S.CustomFIeldPanelDesc>
                {origin === DATASTREAM && this.renderName()}
                <S.CustomFieldTemplateAreaWrapper>
                    <div>
                        {this.fieldCreationOption === START_FROM_SCRATCH
                            ? this.renderModeOptionDropdown()
                            : this.renderTemplateDropdown()}
                    </div>

                    {this.mode.id &&
                        this.mode.id !== EDITOR_MODE.metric &&
                        this.wrapTooltip({
                            title: (
                                <S.TooltipWrapper>
                                    <InfoIcon
                                        class="info-icon-tooltip"
                                        v-view-box
                                    />
                                    {tooltipMessage()}
                                </S.TooltipWrapper>
                            ),
                            content: <InfoIcon class="info-icon" v-view-box />,
                            visible: true,
                            placement: 'bottom',
                        })}
                </S.CustomFieldTemplateAreaWrapper>
                {this.renderCodeEditor()}
                <S.DropdownButtonWrapper slot="confirmButton">
                    <DropdownButton
                        cb={onConfirm}
                        text={
                            isEditing
                                ? this.$t('COMMON.apply')
                                : this.$t('COMMON.create')
                        }
                        options={[
                            {
                                text: this.$t(
                                    'EXPORT_DATA.custom_field_template_save_as'
                                ),
                                cb: () => (this.newTemplateModalOpen = true),
                            },
                        ]}
                        confirmOnlyDisabled={!this.checkIsValid()}
                    ></DropdownButton>
                </S.DropdownButtonWrapper>
            </Drawer>
        );
    },
};
